import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { ACCEPT_SESSION_TRANSFER, ACCEPT_SESSION_TRANSFER_SUCCESS, ACCEPT_SESSION_TRANSFER_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* AcceptSessionTransfer({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { transferId } = payload.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/transfer-requests/${transferId}/accept`,
      method: 'POST',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: ACCEPT_SESSION_TRANSFER_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: ACCEPT_SESSION_TRANSFER_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: ACCEPT_SESSION_TRANSFER_ERROR, payload: error });
  }
}

export function* watchAcceptSessionTransfer() {
  yield takeEvery(ACCEPT_SESSION_TRANSFER, AcceptSessionTransfer);
}

function* AcceptSessionTransferSaga() {
  yield all([fork(watchAcceptSessionTransfer)]);
}

export default AcceptSessionTransferSaga;
